import axios from "axios";
import {setToast} from "@/utils";
import {getLoadingStore} from "@/store/LoadingStore";

let delayTimer = null;
const DELAY = 500;

const initializeApp = (token, type) => {
    const requestId = axios.interceptors.request.use(
        (config) => {
            if (config.headers?.skipInterceptor) return config;
            if(type === "admin"){
                getLoadingStore().startLoading();
                if (!delayTimer) {
                    delayTimer = setTimeout(() => {
                        getLoadingStore().setLoadingState(true);
                    }, DELAY);
                }
            }
            return config;
        },
        (error) => Promise.reject(error)
    );


    const responseId = axios.interceptors.response.use((response) => {
        if(type === "admin"){
            getLoadingStore().setLoadingState(false);
            if (delayTimer) {
                clearTimeout(delayTimer);
                delayTimer = null;
            }
        }
        if ( response?.config?.url?.includes("code-groups") && response?.data?.error?.message === "name 필드는 필수입니다.") {
            setToast("error", "입력된 내용이 없습니다.");
        } else if (response?.data?.error) {
            setToast("error", response.data.error.message);
            throw new Error(response.data.error.message);
        }
        return response;
    },
    async (error) => {
        if (error.config) {
            getLoadingStore().setLoadingState(false);
            if (delayTimer) {
                clearTimeout(delayTimer);
                delayTimer = null;
            }
        }
        const res = error.response;
        if(res.status === 500){
            setToast("error", "에러가 발생했습니다.\n관리자에 문의주세요.");
        }
        if(res.status === 400){
            if(res.data.error.indexOf("User is not exist") > -1){
                setToast("error", "회원 정보가 없습니다.\n관리자에 문의주세요.");
            } else {
                setToast("error", res.data.error);
            }
        }

        if (res.status === 401) {
            if(res.data.error === "wrong password"){
                setToast("error", "비밀 번호가 맞지 않습니다.\n관리자에 문의주세요.");
            }
            if (typeof window !== "undefined") {
                window.location.href = "/admin/login";
            }
        }
        return Promise.reject(res.data);
    }
    );

    return () => {
        axios.interceptors.request.eject(requestId);
        axios.interceptors.response.eject(responseId);
    };
};

export default initializeApp;
